import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { money } from "@/lib/api";

const Th = ({ children, right }) => <th className={`py-2 pr-3 ${right ? "text-right" : ""}`}>{children}</th>;

export const PenalitesPanel = ({ penalites, total }) => (
  <Panel title="TPS/TVQ comprises dans les pénalités d'annulation" testId="bilan-penalites-panel">
    {!penalites.length ? (
      <p className="text-sm text-slate-500" data-testid="bilan-penalites-vide">Aucune pénalité d'annulation cette année.</p>
    ) : (
      <div className="overflow-x-auto">
        <SmartTable id="penalites" data-export-titre="TPS-TVQ pénalités" className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500">
            <Th>Date</Th><Th>Réservation</Th><Th>Voyageur</Th><Th>Logement</Th><Th right>Pénalité payée</Th><Th right>TPS</Th><Th right>TVQ</Th><Th right>À remettre</Th>
          </tr></thead>
          <tbody>
            {penalites.map((p) => (
              <tr key={p.code} className="border-t border-slate-100" data-testid={`bilan-penalite-${p.code}`}>
                <td className="py-2 pr-3 tabular">{p.date}</td><td className="py-2 pr-3 font-mono text-xs">{p.code}</td>
                <td className="py-2 pr-3">{p.nom_client || "—"}</td><td className="py-2 pr-3 text-slate-600">{p.logement}</td>
                <td className="py-2 pr-3 text-right tabular">{money(p.montant)}</td><td className="py-2 pr-3 text-right tabular">{money(p.tps)}</td>
                <td className="py-2 pr-3 text-right tabular">{money(p.tvq)}</td><td className="py-2 text-right tabular font-medium text-amber-700">{money(p.total)}</td>
              </tr>
            ))}
            <tr className="border-t-2 border-slate-300 font-semibold" data-st-fixe="">
              <td className="py-2 pr-3" colSpan={4}>Total de l'année</td>
              <td className="py-2 pr-3 text-right tabular">{money(total.montant)}</td><td className="py-2 pr-3 text-right tabular">{money(total.tps)}</td>
              <td className="py-2 pr-3 text-right tabular">{money(total.tvq)}</td>
              <td className="py-2 text-right tabular text-amber-700" data-testid="bilan-penalites-total">{money(total.total)}</td>
            </tr>
          </tbody>
        </SmartTable>
        <p className="mt-3 text-xs text-slate-500">Une pénalité d'annulation conservée est réputée inclure la TPS et la TVQ (art. 182 de la Loi sur la taxe d'accise) : montant × 5/114,975 et × 9,975/114,975, calculé sur le montant payé par le voyageur. Ces montants sont ajoutés à la TPS/TVQ attendue des trimestres. À confirmer avec votre comptable.</p>
      </div>
    )}
  </Panel>
);
